// static/script/Manager/Hawk3DCore.js

class Hawk3DCore {
    constructor(elementId) {
        this.viewer = document.getElementById(elementId);
        
        if (this.viewer) {
        } else {
        }
        
        this.emissiveAnimationFrame = null;
        this.startTime = null;
        this.duration = 200;
        
        this.materialNames = {
            "yastik-logo.001": "Yastık Logosu", "arkalogo.001": "Arka Logo", "bel-logo": "Bel Logosu", "ustlogo.001": "Ön Logo",
            "ust-logo": "Yastık Logosu", "logo-arkaa": "Arka Logo", "on-logo": "Ön Logo", "nickname": "Yastık Logosu",
            "arka-logo": "Arka Logo", "onlogo": "Ön Logo", "yastiklogo.004": "Yastık Logosu", "arkalogo": "Arka Logo"
        };
        
        this.allowedMaterials = {
            future: ["yastik-logo.001", "arkalogo.001", "bel-logo", "ustlogo.001"],
            fab: ["ust-logo", "logo-arkaa", "bel-logo", "on-logo"],
            fame: ["nickname", "arka-logo", "bel-logo", "onlogo"],
            pro: ["yastiklogo.004", "arkalogo", "bel-logo", "onlogo"],
            aksesuar: ["yastik-logo.001", "bel-logo"]
        };
    }

    loadModel(url, onLoadCallback) {
        if (!this.viewer) return;

        // --- SADE LOADER AÇ ---
        const midLoader = document.getElementById('midLoader');
        const clickBlocker = document.getElementById('clickBlocker');

        if(clickBlocker) clickBlocker.style.display = 'block';
        if(midLoader) midLoader.style.display = 'block';
        // ----------------------

        this.viewer.src = url;

        this.viewer.addEventListener('load', () => {
            if (onLoadCallback) onLoadCallback();

            // --- SADE LOADER KAPAT ---
            if(clickBlocker) clickBlocker.style.display = 'none';
            if(midLoader) midLoader.style.display = 'none';
            
            if (window.hawkLoader) window.hawkLoader.hide();

        }, { once: true });

        // Hata Durumu
        this.viewer.addEventListener('error', (e) => {
            
            // Hatada da kapat ki sistem kilitli kalmasın
            if (midLoader) midLoader.style.display = 'none';
            if (clickBlocker) clickBlocker.style.display = 'none';
            if (window.hawkLoader) window.hawkLoader.hide();
            
            alert("Model yüklenirken bir sorun oluştu. Lütfen sayfayı yenileyin.");
        }, { once: true });

        // Click Eventleri
        this.viewer.onclick = null; 
        this.viewer.addEventListener('dblclick', (event) => this.handleModelClick(event));
    }

    handleModelClick(event) {
        if (!this.viewer.modelIsVisible) return;
        const material = this.viewer.materialFromPoint(event.clientX, event.clientY);
        if (material) {
            const category = (window.cinsbutton && window.cinsbutton[0]) ? window.cinsbutton[0] : "future";
            this.applyEmissiveEffect(material, category);
        }
    }

    applyEmissiveEffect(material, category) {
        const allowedList = this.allowedMaterials[category] || [];
        if (!allowedList.includes(material.name)) return;
        if (!this.isButtonVisible(material.name)) return;

        const startEmissive = [0, 0, 0];
        const targetEmissive = [3, 0, 0];

        const animate = (time) => {
            if (!this.startTime) this.startTime = time;
            const elapsed = time - this.startTime;
            const progress = Math.min(elapsed / this.duration, 1);
            const current = startEmissive.map((s, i) => s + (targetEmissive[i] - s) * progress);
            material.setEmissiveFactor(current);

            if (progress < 1) {
                this.emissiveAnimationFrame = requestAnimationFrame(animate);
            } else {
                this.startTime = null;
                this.emissiveAnimationFrame = requestAnimationFrame(reverse);
                if (window.hawkUI) {
                    window.hawkUI.triggerMaterialPopup(material.name, category);
                }
            }
        };

        const reverse = (time) => {
            if (!this.startTime) this.startTime = time;
            const elapsed = time - this.startTime;
            const progress = Math.min(elapsed / this.duration, 1);
            const current = targetEmissive.map((t, i) => t + (startEmissive[i] - t) * progress);
            material.setEmissiveFactor(current);

            if (progress < 1) {
                this.emissiveAnimationFrame = requestAnimationFrame(reverse);
            }
        };

        cancelAnimationFrame(this.emissiveAnimationFrame);
        this.startTime = null;
        this.emissiveAnimationFrame = requestAnimationFrame(animate);
    }

    isButtonVisible(materialName) {
        const map = {
            "arkalogo.001": "arkaLogoEkle", "logo-arkaa": "arkaLogoEkle", "arka-logo": "arkaLogoEkle", "arkalogo": "arkaLogoEkle",
            "bel-logo": "belLogoEkle",
            "ustlogo.001": "önLogoEkle", "on-logo": "önLogoEkle", "onlogo": "önLogoEkle",
            "yastik-logo.001": "yastikLogoEkle", "ust-logo": "yastikLogoEkle", "yastiklogo.004": "yastikLogoEkle",
            "nickname": "isimYazdirma"
        };
        const id = map[materialName];
        if (!id) return true;
        const btn = document.getElementById(id);
        return btn && btn.style.display !== 'none';
    }

    getModelMaterials() {
        if (!this.viewer || !this.viewer.model) return [];
        return this.viewer.model.materials;
    }

    initSkybox() {
        const buttons = document.querySelectorAll('.environment2');
        const skyboxImages = {
            birenvironment: "/static/hdri/env6.png",
            birenvironment2: "/static/hdri/env5.png",
            birenvironment3: "/static/hdri/env2.png",
            birenvironment4: "/static/hdri/envmushroom.png",
            birenvironment5: "/static/hdri/envcloud.png",
            birenvironment6: "/static/hdri/env0.png"
        };
        buttons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const imgPath = skyboxImages[e.target.id];
                if (imgPath && this.viewer) {
                    this.viewer.setAttribute('skybox-image', imgPath);
                }
            });
        });
    }
}

window.hawk3D = new Hawk3DCore('hawkgamingchair');